<div class="mb-3">
  @if (control().hasLabel) {
    <mat-label [style.color]="control().labelColour">{{ control().label }}</mat-label>
  }
  <mat-list class="mat-list-dynamic">
    @for (item of medicationList(); track (item.id + item.description + item.diagnosisCode + item.dosage); let i = $index) {
      <mat-list-item [style.color]="control().valueColour">
        @if (item.comment) {
          <span matListItemLine>{{ i + 1 }} - {{ item.description }} - {{ item.diagnosisCode }}</span>
        }
        @if (!item.comment) {
          <span>{{ i + 1 }} - {{ item.description }} - {{ item.diagnosisCode }}</span>
        }
        @if (item.comment) {
          <span matListItemLine>{{ item.comment }}</span>
        }
      </mat-list-item>
    }
  </mat-list>
</div>
